/*eslint no-unused-expressions: [
  "error", {
    "allowShortCircuit": true
  }]*/
import React, {Component} from "react";
import { connect } from "react-redux";
import {
    setgeneralDetails
} from "../../actions/setgeneraldetailsaction";
import { Link } from "react-router-dom";
import { Oval } from  'react-loader-spinner'
import {serverLink} from "../../resources/url";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import axios from "axios";
import swal from "sweetalert";
import Header from "../Header/header";
class AlumniFeedbackList extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: true,
            columns: [
                {
                    name: "StudentID",
                    selector: row => `${row.StudentID}`,
                    sortable: true,
                },
                {
                    name: "Student Name",
                    selector: row => `${row.StudentName}`,
                    sortable: true
                },
                {
                    name: "Title",
                    selector: row => `${row.Title}`,
                    sortable: true
                },
                {
                    name: "Images",
                    selector: row => <img src={`${serverLink}public/uploads/alumni/${row.ImagePath}`}
                                          className="w-65px me-3" alt=""/>,
                    sortable: true
                },
                {
                    name: "Action",
                    cell: (row) => (
                        <a href={`https://www.oliviauniversity.com/${row.Title}`} target="_blank" className="btn btn-primary btn-sm">
                            <i className="fa fa-eye" aria-hidden="true"/>
                        </a>

                    ),
                },
                {
                    name: "Action",
                    cell: (row) => (
                            <button
                                type="button"
                                onClick={async () => this.showConfirmAlert("Confirm", "ARE YOU SURE YOU WANT TO DELETE THIS RECORD?", "warning", row)
                                    }
                                className="btn btn-danger btn-sm"
                            >
                                <i className="fa fa-trash-alt" aria-hidden="true"/>
                            </button>
                    ),
                },

            ],
            data: []
        }
    }

    componentDidMount() {
        this.fetchAllumniFeedback();
    }

    async fetchAllumniFeedback() {
        await axios.get(`${serverLink}student/alumni/feedback`)
            .then(data => {
                const result = data.data;
                this.setState({
                    data: [...result]

                });
                });

    this.setState({isLoading: false})
    }


  async  onDelete(data) {
        await axios.delete(`${serverLink}student/alumin/feedback/delete/${data.ImagePath}/${data.EntryID}`)
            .then(data => {
                const result = data.data;

                if (result.message === "deleted") {
                    this.fetchAllumniFeedback();
                     this.showAlert("SUCCESS", "RECORD DELETED SUCCESSFULLY", "success")

                    return false;
                }

                console.log(result);
            });
    }

    showSuccessAlert(title, msg, type){
        return swal({
            title: title,
            text: msg,
            icon: type,
            button: "OK",
        }).then((value) => {
            window.location.href = '/alumni/feedback/list';
        });
    }

    showConfirmAlert(title, msg, type, data){
        return  swal({
                title: title,
                text: msg,
                type: type,
                confirmButtonColor: '#DD6B55',
                buttons: true,
                dangerMode: true,
                },).then((isConfirm)=>{
                if (isConfirm){
                    this.onDelete(data);
                } else {

                }
            });
        }

    showAlert(title, msg, type){
        return swal({
            title: title,
            text: msg,
            icon: type,
            button: "OK",
        });
    }


    render() {
        const columns = this.state.columns;
        const data = this.state.data;
        const tableData = {
            columns,
            data,
            print: false,
            exportHeaders: true,
            filterPlaceholder: 'Search Alumni Feedback',

        };
        return (
            <>
                <Header isFaculty={false}/>
            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                <div className="toolbar" id="kt_toolbar">
                    <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">Alumni
                                <span className="h-20px border-dark  border-start ms-3 mx-2"/>
                                Feedback
                                <span className="h-20px border-dark  border-start ms-3 mx-2"/>
                                 List
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="post d-flex flex-column-fluid" id="kt_post">
                    <div id="kt_content_container" className="container-fluid">
                        {/* CONTENT START */}
                        {this.state.isLoading ?
                            <div style={{margin: 'auto', position: 'relative', justifyContent:'center', alignItems: 'center', display: 'flex' , height: '400px'}}>
                                <Oval
                                    type="Oval"
                                    color="#eeeeee"
                                    height={50}
                                    width={50}
                                    secondaryColor="teal"
                                    timeout={15000} //3 secs
                                />
                            </div>
                            :
                            <div className="card mb-5 mb-xl-10">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h3>ALUMNI FEEDBACK LIST</h3>
                                    </div>
                                    <span className="mt-5" style={{float: 'right'}}>
                                            <Link to="/alumni/list" className="btn btn-primary">
                                                <i className="fa fa-plus"/> Add Alumni Feedback
                                            </Link>
                                            </span>

                                </div>

                                <div className="card-body"  style={{textAlign: 'left'}}>
                                    <DataTableExtensions
                                        {...tableData}
                                    >
                                        <DataTable
                                            noHeader
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover/>
                                    </DataTableExtensions>

                                </div>

                            </div>}

                        {/* CONTENT END */}
                    </div>
                </div>
            </div>
                </>
        )
    }
}

const mapDisptachToProps = (dispatch) => {
    return {
        setOnGeneralDetails: (p) => {
            dispatch(setgeneralDetails(p));
        },
    };
};

export default connect(null, mapDisptachToProps)(AlumniFeedbackList);